import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type AuthInfoBoxProps = {
  title: string;
  description?: ReactNode;
  /** Secondary content rendered next to the description, e.g. a "Zmień" link. */
  action?: ReactNode;
  /** Keeps a long value (an e-mail address) on a single ellipsised line. */
  truncateDescription?: boolean;
  className?: string;
};

/**
 * Grey header block used by every auth step. It spans the full width of the
 * mobile drawer and becomes a rounded card from the tablet breakpoint up.
 */
export const AuthInfoBox = ({
  title,
  description,
  action,
  truncateDescription = false,
  className,
}: AuthInfoBoxProps) => (
  <div
    className={cn(
      "flex flex-col gap-1 bg-background-surface-secondary px-4 py-3 text-brand-black-200",
      "max-md:-mx-4 md:rounded-lg",
      className,
    )}
  >
    <p className="font-medium text-base leading-6">{title}</p>
    {description || action ? (
      <div className="flex items-start justify-between gap-1">
        {description ? (
          <p
            className={cn(
              "min-w-0 flex-1 text-sm leading-[22px]",
              truncateDescription && "truncate",
            )}
          >
            {description}
          </p>
        ) : null}
        {action}
      </div>
    ) : null}
  </div>
);
